import { GlAvatar, GlBadge, GlPopover, GlSprintf } from '@gitlab/ui';
import { groupBy } from 'lodash-es';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import { s__ } from '~/locale';
import { TYPENAME_USER } from '~/graphql_shared/constants';
import timeagoMixin from '~/vue_shared/mixins/timeago';
import { joinPaths, stripRelativeUrlRootFromPath } from '~/lib/utils/url_utility';
import SafeHtml from '~/vue_shared/directives/safe_html';
import getUserAchievements from './graphql/get_user_achievements.query.graphql';
export default {
    name: 'UserAchievements',
    directives: {
        SafeHtml
    },
    components: {
        GlAvatar,
        GlBadge,
        GlPopover,
        GlSprintf
    },
    mixins: [
        timeagoMixin
    ],
    inject: [
        'rootUrl',
        'userId'
    ],
    data () {
        return {
            userAchievements: undefined
        };
    },
    apollo: {
        userAchievements: {
            query: getUserAchievements,
            variables () {
                return {
                    id: convertToGraphQLId(TYPENAME_USER, this.userId)
                };
            },
            update (data) {
                return this.processNodes(data.user.userAchievements.nodes);
            },
            error () {
                return [];
            }
        }
    },
    computed: {
        hasUserAchievements () {
            return Boolean(this.userAchievements?.length);
        }
    },
    methods: {
        processNodes (nodes) {
            return Object.entries(groupBy(nodes, 'achievement.id')).map(([id, values])=>{
                const sortedValues = [
                    ...values
                ].sort((a, b)=>new Date(a.createdAt) - new Date(b.createdAt));
                const { achievement: { name, avatarUrl, description, namespace }, createdAt } = sortedValues[0];
                const mostRecent = sortedValues[sortedValues.length - 1];
                const count = values.length;
                return {
                    id: `user-achievement-${id}`,
                    name,
                    createdAt,
                    timeAgo: this.timeFormatted(createdAt),
                    avatarUrl: avatarUrl || gon.gitlab_logo,
                    description,
                    awardMessageHtml: mostRecent.awardMessageHtml,
                    namespace: namespace && {
                        fullPath: namespace.fullPath,
                        webUrl: joinPaths(this.rootUrl, stripRelativeUrlRootFromPath(namespace.achievementsPath))
                    },
                    count
                };
            });
        },
        achievementAwardedMessage (userAchievement) {
            return userAchievement.namespace ? this.$options.i18n.awardedBy : this.$options.i18n.awardedByUnknownNamespace;
        },
        showCountBadge (count) {
            return count > 1;
        },
        getCountBadge (count) {
            return `${count}x`;
        }
    },
    i18n: {
        awardedBy: s__('Achievements|Awarded %{timeAgo} by %{namespace}'),
        awardedByUnknownNamespace: s__('Achievements|Awarded %{timeAgo} by a private namespace'),
        achievementsLabel: s__('Achievements|Achievements')
    }
};
